module.exports = __webpack_public_path__ + "static/media/swiss-knife.bea5dd29.png";